import { Action } from 'redux';
import { PopOverSceneItemData } from 'sofa-reborn-react';

// State
export interface MissingState {
	unfinishedSections: PopOverSceneItemData[];
	missingCoverSections: PopOverSceneItemData[];
	standaloneSofabed: PopOverSceneItemData[];
	unfinishedModule: PopOverSceneItemData | null;
}

// Actions
export const SET_FAULTY_SECTIONS = 'SET_FAULTY_SECTIONS';
export const SET_UNFINISHED_MODULE = 'SET_UNFINISHED_MODULE';

interface SetFaultySections extends Action {
	type: typeof SET_FAULTY_SECTIONS;
	unfinishedSections: PopOverSceneItemData[];
	missingCoverSections: PopOverSceneItemData[];
	standaloneSofabed: PopOverSceneItemData[];
}

interface SetUnfinishedModule extends Action {
	type: typeof SET_UNFINISHED_MODULE;
	value: PopOverSceneItemData | null;
}

export type MissingStateActions = SetFaultySections | SetUnfinishedModule;
